import WorkspaceModel from './WorkspaceModel';

export default class GraphModel {
    parent: WorkspaceModel | null;
    label: string;
    leaf: boolean = true;
    selectable: boolean = true;
    key: string;

    constructor(parent: WorkspaceModel, data: object) {
        this.parent = parent;
        this.label = data.name
        this.key = parent.id + '_' + data.id;

        // create all properties from data
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }
    }
}